import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuLayout from "./MenuLayout";
import "../styles/PaymentResultPage.css";

const PaymentCancelPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderId, debugRows } = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const getParam = (keys) => keys.map((key) => params.get(key)).find((val) => val);
    const orderIdValue = getParam(["order_id", "order"]);
    const errorValue = getParam(["error"]);
    const refNum = getParam(["ref_num", "refnum"]);
    const trackingCode = getParam(["tracking_code", "trackingCode"]);
    const statusParam = getParam(["status", "Status"]);
    const amountValue = getParam(["amount", "payment_amount"]);
    const verifyStatus = getParam(["verify_status"]);
    const verifyMessage = getParam(["verify_message"]);
    const verifyError = getParam(["verify_error"]);

    const errorMessages = {
      missing_ref_num: "مرجع تراکنش از درگاه دریافت نشد.",
      payment_not_found: "سفارش پیدا نشد.",
      payment_not_confirmed: "پرداخت تایید نشده است.",
      paystar_sign_failed: "امضای درگاه نامعتبر است.",
      paystar_verify_failed: "تایید پرداخت از سمت درگاه ناموفق شد.",
      payment_process_failed: "ثبت عملیات پرداخت در سیستم انجام نشد.",
      payment_failed: "نتیجه تایید پرداخت از درگاه ناموفق بود.",
    };

    const errorText = errorValue ? errorMessages[errorValue] || errorValue : "";
    const rows = [
      errorValue && { label: "کد خطا", value: errorValue },
      errorText && { label: "توضیح خطا", value: errorText },
      orderIdValue && { label: "شناسه سفارش", value: orderIdValue },
      refNum && { label: "ref_num", value: refNum },
      trackingCode && { label: "کد پیگیری", value: trackingCode },
      statusParam && { label: "وضعیت درگاه", value: statusParam },
      amountValue && { label: "مبلغ", value: amountValue },
      verifyStatus && { label: "verify_status", value: verifyStatus },
      verifyMessage && { label: "verify_message", value: verifyMessage, mono: true },
      verifyError && { label: "verify_error", value: verifyError, mono: true },
      location.search && { label: "query", value: location.search, mono: true },
    ].filter(Boolean);

    return {
      orderId: orderIdValue,
      debugRows: rows,
    };
  }, [location.search]);

  const metaRows = [orderId && { label: "شناسه سفارش", value: orderId }].filter(Boolean);

  return (
    <MenuLayout>
      <div className="payment-page">
        <header className="payment-header">
          <span className="payment-badge error">پرداخت ناموفق</span>
          <h1 className="payment-title">پرداخت شما انجام نشد</h1>
          <p className="payment-subtitle">
            اگر مبلغ از حساب شما کسر شده باشد، طی ۲۴ تا ۷۲ ساعت به صورت خودکار بازگشت داده می‌شود.
          </p>
        </header>

        <div className="payment-card error">
          <div className="payment-content">
            <h2 className="payment-content-title">چه کاری می‌توانم انجام دهم؟</h2>
            <p className="payment-note">
              می‌توانید دوباره پرداخت را تلاش کنید یا از طریق پشتیبانی پیگیری کنید تا مشکل بررسی شود.
            </p>

            {metaRows.length > 0 && (
              <div className="payment-meta">
                {metaRows.map((row) => (
                  <div className="payment-meta-row" key={row.label}>
                    <span className="payment-meta-label">{row.label}</span>
                    <span className="payment-meta-value">{row.value}</span>
                  </div>
                ))}
              </div>
            )}

            {debugRows.length > 0 && (
              <>
                <h3 className="payment-content-title">جزئیات خطا (تست)</h3>
                <div className="payment-meta">
                  {debugRows.map((row) => (
                    <div className="payment-meta-row" key={row.label}>
                      <span className="payment-meta-label">{row.label}</span>
                      <span
                        className="payment-meta-value"
                        style={row.mono ? { fontFamily: "monospace", fontSize: 12, wordBreak: "break-all" } : undefined}
                      >
                        {row.value}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}

            <div className="payment-actions">
              <button className="payment-btn primary" onClick={() => navigate("/cart")}>
                بازگشت به سبد خرید
              </button>
              <button className="payment-btn ghost" onClick={() => navigate("/tickets")}>
                ارتباط با پشتیبانی
              </button>
            </div>
          </div>

          <div className="payment-visual">
            <img src="/images/err.png" alt="پرداخت ناموفق" />
          </div>
        </div>
      </div>
    </MenuLayout>
  );
};

export default PaymentCancelPage;
